/**
 * BackendConnectionTag automatically generated by SDKgen please do not edit this file manually
 * {@link https://sdkgen.app}
 */

import {TagAbstract, HttpRequest} from "sdkgen-client"
import {ClientException, UnknownStatusCodeException} from "sdkgen-client";

import {BackendConnection} from "./BackendConnection";
import {BackendConnectionAgentTag} from "./BackendConnectionAgentTag";
import {BackendConnectionCollection} from "./BackendConnectionCollection";
import {BackendConnectionCreate} from "./BackendConnectionCreate";
import {BackendConnectionDatabaseTag} from "./BackendConnectionDatabaseTag";
import {BackendConnectionFilesystemTag} from "./BackendConnectionFilesystemTag";
import {BackendConnectionHttpTag} from "./BackendConnectionHttpTag";
import {BackendConnectionIndex} from "./BackendConnectionIndex";
import {BackendConnectionRedirectResponse} from "./BackendConnectionRedirectResponse";
import {BackendConnectionSdkTag} from "./BackendConnectionSdkTag";
import {BackendConnectionUpdate} from "./BackendConnectionUpdate";
import {CommonFormContainer} from "./CommonFormContainer";
import {CommonMessage} from "./CommonMessage";
import {CommonMessageException} from "./CommonMessageException";

export class BackendConnectionTag extends TagAbstract {
    public agent(): BackendConnectionAgentTag
    {
        return new BackendConnectionAgentTag(
            this.httpClient,
            this.parser
        );
    }

    public database(): BackendConnectionDatabaseTag
    {
        return new BackendConnectionDatabaseTag(
            this.httpClient,
            this.parser
        );
    }

    public filesystem(): BackendConnectionFilesystemTag
    {
        return new BackendConnectionFilesystemTag(
            this.httpClient,
            this.parser
        );
    }

    public http(): BackendConnectionHttpTag
    {
        return new BackendConnectionHttpTag(
            this.httpClient,
            this.parser
        );
    }

    public sdk(): BackendConnectionSdkTag
    {
        return new BackendConnectionSdkTag(
            this.httpClient,
            this.parser
        );
    }

    /**
     * Creates a new connection
     *
     * @returns {Promise<CommonMessage>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async create(payload: BackendConnectionCreate): Promise<CommonMessage> {
        const url = this.parser.url('/backend/connection', {
        });

        let request: HttpRequest = {
            url: url,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            params: this.parser.query({
            }, [
            ]),
            data: payload
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as CommonMessage;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Deletes an existing connection
     *
     * @returns {Promise<CommonMessage>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async delete(connectionId: string): Promise<CommonMessage> {
        const url = this.parser.url('/backend/connection/$connection_id<[0-9]+|^~>', {
            'connection_id': connectionId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'DELETE',
            headers: {
            },
            params: this.parser.query({
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as CommonMessage;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Returns a specific connection
     *
     * @returns {Promise<BackendConnection>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async get(connectionId: string): Promise<BackendConnection> {
        const url = this.parser.url('/backend/connection/$connection_id<[0-9]+|^~>', {
            'connection_id': connectionId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as BackendConnection;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Returns a paginated list of connections
     *
     * @returns {Promise<BackendConnectionCollection>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async getAll(startIndex?: number, count?: number, search?: string, _class?: string): Promise<BackendConnectionCollection> {
        const url = this.parser.url('/backend/connection', {
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
                'startIndex': startIndex,
                'count': count,
                'search': search,
                'class': _class,
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as BackendConnectionCollection;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Returns all available connection classes
     *
     * @returns {Promise<BackendConnectionIndex>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async getClasses(): Promise<BackendConnectionIndex> {
        const url = this.parser.url('/backend/connection/list', {
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as BackendConnectionIndex;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Returns the connection config form
     *
     * @returns {Promise<CommonFormContainer>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async getForm(_class?: string): Promise<CommonFormContainer> {
        const url = this.parser.url('/backend/connection/form', {
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
                'class': _class,
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as CommonFormContainer;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Returns a redirect url to start the OAuth2 authorization flow for the given connection
     *
     * @returns {Promise<BackendConnectionRedirectResponse>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async getRedirect(connectionId: string): Promise<BackendConnectionRedirectResponse> {
        const url = this.parser.url('/backend/connection/:connection_id/redirect', {
            'connection_id': connectionId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as BackendConnectionRedirectResponse;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Updates an existing connection
     *
     * @returns {Promise<CommonMessage>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async update(connectionId: string, payload: BackendConnectionUpdate): Promise<CommonMessage> {
        const url = this.parser.url('/backend/connection/$connection_id<[0-9]+|^~>', {
            'connection_id': connectionId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            params: this.parser.query({
            }, [
            ]),
            data: payload
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as CommonMessage;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }



}
